import React from "react"
import { compose, withPropsOnChange } from "recompose"

import isEmpty from "lodash/isEmpty"
import merge from "lodash/merge"
import keyBy from "lodash/keyBy"
import map from "lodash/map"
import mapValues from "lodash/mapValues"

import { getActualChecks } from "../../../api/entities/actualChecks"
import withApiTransport from "../../../api/apiTransport"

const convertTime = 3600000

const toHumanizeDuration = time => {
  const secNum = parseInt(time / 1000, 10)
  let days = Math.floor(secNum / (3600 * 24))
  let hours = Math.floor((secNum - days * 3600 * 24) / 3600)
  let minutes = Math.floor((secNum - hours * 3600 - days * 3600 * 24) / 60)

  if (days && days < 10) {
    days = `0${days}`
  }
  if (hours && hours < 10) {
    hours = `0${hours}`
  }
  if (minutes && minutes < 10) {
    minutes = `0${minutes}`
  }
  return `${days || 0} д. ${hours || 0} ч. ${minutes || 0} м.`
}

const enhance = compose(
  withPropsOnChange([`visits`], ({ visits }) => ({
    load: getActualChecks,
    propName: `actualChecks`,
    payload: map(visits, `id`),
  })),
  withApiTransport,
  withPropsOnChange(
    [`plannedChecks`, `actualChecks`],
    ({ plannedChecks, actualChecks }) => {
      if (isEmpty(plannedChecks) && isEmpty(actualChecks)) {
        return {}
      }
      const planned = mapValues(
        keyBy(plannedChecks, check => {
          let key = ``
          if (check.description) {
            key += check.description
          } else if (check.operationNumber) {
            key += `${check.operationNumber}-`
          }
          return key
        }),
        resource => {
          const planValue = resource.plannedValue && (
            <>
              <div>
                {toHumanizeDuration(convertTime * resource.plannedValue)}
              </div>
            </>
          )
          return {
            ...resource,
            planValue,
            planned: true,
          }
        },
      )
      const actual = mapValues(keyBy(actualChecks, `operation`), resource => {
        const duration = resource.spendTimeFact && (
          <>
            <div>{toHumanizeDuration(resource.spendTimeFact)}</div>
          </>
        )

        return {
          ...resource,
          duration,
          actual: true,
        }
      })
      const preparedChecks = merge(planned, actual)

      return { preparedChecks }
    },
  ),
)

export default enhance
